import { defineMessages } from 'react-intl';

export const baseMessages = defineMessages({
  title: {
    id: 'premium-caps.title',
    defaultMessage: 'Premium Caps',
  },
});

export const commonMessages = defineMessages({
  addCap: {
    id: 'premium-caps.add-cap',
    defaultMessage: 'Add Premium Cap',
  },
  scheduleRule: {
    id: 'premium-caps.rule-entity.schedule',
    defaultMessage: 'Schedule',
  },
  classRule: {
    id: 'premium-caps.rule-entity.class',
    defaultMessage: 'Session',
  },
  venueRule: {
    id: 'premium-caps.rule-entity.venue',
    defaultMessage: 'Date & Time',
  },
  venueDefault: {
    id: 'premium-caps.venue-default',
    defaultMessage: 'Venue default',
  },
  ongoing: {
    id: 'premium-caps.ongoing',
    defaultMessage: 'Ongoing',
  },
});

export const emptyListMessages = defineMessages({
  header: {
    id: 'premium-caps.empty-list.title',
    defaultMessage: 'No premium caps added yet',
  },
  body: {
    id: 'premium-caps.empty-list.body',
    defaultMessage: 'Add your first premium cap to get started',
  },
});

export const listMessages = defineMessages({
  class: {
    id: 'premium-caps.list.class',
    defaultMessage: 'Session',
  },
  schedule: {
    id: 'premium-caps.list.schedule',
    defaultMessage: 'Schedule',
  },
  ruleType: {
    id: 'premium-caps.list.rule-type',
    defaultMessage: 'Rule Type',
  },
  premiumCap: {
    id: 'premium-caps.list.premium-cap',
    defaultMessage: 'Premium Cap',
  },
});

export const listItemMessages = defineMessages({
  edit: {
    id: 'premium-caps.list-item.edit',
    defaultMessage: 'Edit',
  },
  remove: {
    id: 'premium-caps.list-item.delete',
    defaultMessage: 'Remove',
  },
  premiumCap: {
    id: 'premium-caps.list-item.premium-cap',
    defaultMessage: '{premiumCap} out of {totalSpots}',
  },
  editCap: {
    id: 'premium-caps.list.edit-cap',
    defaultMessage: 'Edit',
  },
  timeRange: {
    id: 'premium-caps.list.time-range',
    defaultMessage: '{startDateTime, date, time} - {endDateTime, date, time}',
  },
  starts: {
    id: 'premium-caps.list.starts',
    defaultMessage: 'Starts {date, date, short-w-2-digit-year}',
  },
  started: {
    id: 'premium-caps.list.started',
    defaultMessage: 'Started {date, date, short-w-2-digit-year}',
  },
  dateRange: {
    id: 'premium-caps.list.date-range',
    defaultMessage: '{startDateTime, date, short-w-2-digit-year} - {endDateTime, date, short-w-2-digit-year}',
  },
  singleDate: {
    id: 'premium-caps.list.single-date',
    defaultMessage: 'On {date, date, short-w-2-digit-year}',
  },
});

export const rulesModalMessages = {
  ...defineMessages({
    addTitle: {
      id: 'premium-caps.rules-modal.add-title',
      defaultMessage: 'Add Premium Cap',
    },
    editTitle: {
      id: 'premium-caps.rules-modal.edit-title',
      defaultMessage: 'Edit Premium Cap',
    },
    cancel: {
      id: 'premium-caps.rules-modal.cancel',
      defaultMessage: 'Cancel',
    },
    accept: {
      id: 'premium-caps.rules-modal.accept',
      defaultMessage: 'Save',
    },
  }),
  label: defineMessages({
    ruleEntity: {
      id: 'premium-caps.rules-modal.label-rule-entity',
      defaultMessage: 'Rule type',
    },
    class: {
      id: 'premium-caps.rules-modal.label-class',
      defaultMessage: 'Session',
    },
    schedule: {
      id: 'premium-caps.rules-modal.label-schedule',
      defaultMessage: 'Schedule',
    },
    day: {
      id: 'premium-caps.rules-modal.label-day',
      defaultMessage: 'Day',
    },
    daysOfWeek: {
      id: 'premium-caps.rules-modal.label-days-of-week',
      defaultMessage: 'Repeat On',
    },
    startDate: {
      id: 'premium-caps.rules-modal.label-start-date',
      defaultMessage: 'Start Date (inclusive)',
    },
    endDate: {
      id: 'premium-caps.rules-modal.label-end-date',
      defaultMessage: 'End Date (inclusive)',
    },
    startTime: {
      id: 'premium-caps.rules-modal.label-start-time',
      defaultMessage: 'Start Time (inclusive)',
    },
    endTime: {
      id: 'premium-caps.rules-modal.label-end-time',
      defaultMessage: 'End Time (exclusive)',
    },
    premiumCap: {
      id: 'premium-caps.rules-modal.label-premium-cap',
      defaultMessage: 'Premium Cap',
    },
    allInstances: {
      id: 'premium-caps.rules-modal.label-all-instances',
      defaultMessage: 'All instances',
    },
  }),
  placeholder: defineMessages({
    schedulePicker: {
      id: 'premium-caps.rules-modal.placeholder-select-schedule',
      defaultMessage: 'Select Schedule',
    },
    classPicker: {
      id: 'premium-caps.rules-modal.placeholder-select-class',
      defaultMessage: 'Select Session',
    },
  }),
};

export const rulesValidatorMessages = defineMessages({
  required: {
    id: 'premium-caps.sync-validator.required',
    defaultMessage: 'Required',
  },
  spotCapRange: {
    id: 'premium-caps.sync-validator.spot-cap-range',
    defaultMessage: 'Caps must be between 0 and 9000',
  },
  classIdRequired: {
    id: 'premium-caps.sync-validator.class-id-required',
    defaultMessage: 'Please select a session',
  },
  scheduleIdRequired: {
    id: 'premium-caps.sync-validator.schedule-id-required',
    defaultMessage: 'Please select a schedule',
  },
  dateOrder: {
    id: 'premium-caps.sync-validator.date-order',
    defaultMessage: 'Start Date/Time must occur before End Date/Time',
  },
  timeOrder: {
    id: 'premium-caps.sync-validator.time-order',
    defaultMessage: 'Start Time must occur before End Time',
  },
});

export const sagaMessages = {
  success: defineMessages({
    ruleSaved: {
      id: 'premium-caps.saga.success-rule-saved',
      defaultMessage: 'Rule saved.',
    },
    deleteRule: {
      id: 'premium-caps.saga.success-delete-rule',
      defaultMessage: 'Premium cap deleted',
    },
  }),
  error: defineMessages({
    loadingRules: {
      id: 'premium-caps.saga.error-loading-rules',
      defaultMessage: 'There was a problem loading the premium-cap rules for this venue.',
    },
    savingRule: {
      id: 'premium-caps.saga.error-saving-rule',
      defaultMessage: 'There was a problem saving the premium-cap rule.',
    },
    ruleConflict: {
      id: 'premium-caps.saga.error-rule-conflit',
      defaultMessage: 'This rule conflicts with an existing rule. See form error for details.',
    },
    loadingClasses: {
      id: 'premium-caps.saga.error-loading-classes',
      defaultMessage: 'There was a problem loading the sessions for this venue.',
    },
    loadingSchedules: {
      id: 'premium-caps.saga.error-loading-schedules',
      defaultMessage: 'There was a problem loading the schedules for classId = {classId}',
    },
    deleteRule: {
      id: 'premium-caps.saga.error-delete-rule',
      defaultMessage: 'There was a problem deleting the premium cap.',
    },
    generic: {
      id: 'premium-caps.saga.error-generic',
      defaultMessage: 'There was a problem with the premium cap.',
    },
  }),
  conflict: defineMessages({
    venueDefault: {
      id: 'premium-caps.saga.conflict-venue-default',
      defaultMessage: 'Conflicts with the "Venue default" rule: cap = {spotCap}',
    },
    venue: {
      id: 'premium-caps.saga.conflict-venue',
      defaultMessage: 'Conflicts with a "Date & Time" rule: cap = {spotCap}',
    },
    class: {
      id: 'premium-caps.saga.conflict-class',
      defaultMessage: 'Conflicts with a "Session" rule: {id} ({name}), cap = {spotCap}',
    },
    recurringSchedule: {
      id: 'premium-caps.saga.conflict-recurring-schedule',
      defaultMessage: 'Conflicts with a "Session" rule: {id} ({name}), cap = {spotCap}',
    },
    schedule: {
      id: 'premium-caps.saga.conflict-schedule',
      defaultMessage:
        'Conflicts with a "Schedule" rule: {id} ({name} on {startDateTime, date, full} at {startDateTime, date, time}), cap = {spotCap}',
    },
    generic: {
      id: 'premium-caps.saga.conflict-generic',
      defaultMessage: 'Conflicts with an existing rule',
    },
  }),
};

export const deleteModalMessages = defineMessages({
  title: {
    id: 'premium-caps.delete-modal.title',
    defaultMessage: 'Delete premium cap',
  },
  body: {
    id: 'premium-caps.delete-modal.body',
    defaultMessage: 'Are you sure you want to delete this premium cap?',
  },
  accept: {
    id: 'premium-caps.delete-modal.accept',
    defaultMessage: 'Delete',
  },
  cancel: {
    id: 'premium-caps.delete-modal.cancel',
    defaultMessage: 'Cancel',
  },
});
